module.exports = __webpack_public_path__ + "static/media/166GL.7c4d6ebf.jpg";